import { useEffect, useState } from "react";
import {  useSelector } from "react-redux";
import Styles from "../editScreenStyles.module.css";
import { yesNoUnsure } from "../../../../constants/options";
import { copyNestedObjArray, nameIsBlank, textToBoolean } from "../../../../utilities/dataUtilities";
import inputUtilities from "../../../../utilities/forms/formInputUtilities";

function InjuredPedestriansEdit({
  pedestrians,
  setPedestrians,
  setIsVisible,
  isVisible,
  fields,
  utilities,
  validatePage,
  cancel
}) {
 const [emptyPeds, setEmptyPeds] = useState([]);
 const [originalPeds, setOriginalPeds] = useState([]);
 let injuredObj = useSelector((state) => state.anonAutoForm.injuredObj);

  const {
    createToggleInput
  } = utilities;

  const addPedestrian = (index) => {
    const newPedestrian = {
      firstName: {...injuredObj.firstName},
      lastName: {...injuredObj.lastName}
    };
    for (let fieldName in newPedestrian) {
      newPedestrian[fieldName] = {
        ...newPedestrian[fieldName],
        fieldName: `${newPedestrian[fieldName].fieldName}${pedestrians.length + index}`
      };
    }
    return newPedestrian;
  };

  const createPedestrian = (pedestrian, index, pedArray, setPedArray) => {
    const setPedestrian = (ped) => {
      const newPedestrianInfo = [...pedArray];
      newPedestrianInfo[index] = ped;
      setPedArray(newPedestrianInfo);
    };
    const createPedInput = inputUtilities(
      pedestrian,
      setPedestrian,
      Styles
    ).createEditScreenInput;
    return (
      <li key={pedestrian.firstName.fieldName} className={`${Styles.row} ${Styles.personContainer}`}>
        {createPedInput(pedestrian.firstName, "100%", Styles.input, Styles.blockLabel)}
        {createPedInput(pedestrian.lastName, "100%", Styles.input, Styles.blockLabel)}
      </li>
    );
  };

  const updateClicked = () => {
    if (validatePage(10, true)) {
      const newPedestrians = [...pedestrians];
      emptyPeds
        .filter((ped) => !nameIsBlank(ped))
        .map((ped) => newPedestrians.push(ped));
      setPedestrians(newPedestrians);
      setEmptyPeds([]);
      setIsVisible(false);
    }//add new pedestrians if information was added
  };

  const cancelClicked = () => {
    setPedestrians([...originalPeds]);
    setEmptyPeds([]);
    cancel();
  };

  useEffect(() => {
    setOriginalPeds(copyNestedObjArray(pedestrians));
  }, [isVisible]);

  useEffect(() => {
    if ((pedestrians.length + emptyPeds.length) < 4) {
      const numToAdd = 4 - pedestrians.length - emptyPeds.length;
      const peds = [...emptyPeds];
      for (let i = 0; i < numToAdd; i++) {
        peds.push(addPedestrian(i));
      }
      setEmptyPeds(peds);
    } 
  }, [pedestrians.length, emptyPeds.length])

  useEffect(() => {
    if (!textToBoolean(fields.pedestrianInjured.value)) {
      setPedestrians([]);
    }
  }, [fields.pedestrianInjured.value])

  return (
    <div className={Styles.modalContainer}>
      <div className={Styles.title}>Injured Pedestrians</div>
      {createToggleInput(fields.pedestrianInjured, "100%", yesNoUnsure, true)}
      <div className={Styles.column}>
        {textToBoolean(fields.pedestrianInjured.value) &&
          pedestrians?.map((pedestrian, index) => createPedestrian(pedestrian, index, pedestrians, setPedestrians))
        }
        {
          textToBoolean(fields.pedestrianInjured.value) &&
            emptyPeds?.map((pedestrian, index) => createPedestrian(pedestrian, index, emptyPeds, setEmptyPeds))
        }
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default InjuredPedestriansEdit;
